<app-header-nav-case></app-header-nav-case>
<!-- begin::Body -->
<router-outlet></router-outlet>
<!-- end::Body -->
<!-- <app-footer></app-footer> -->